{
    "AllTelServer": "[Tous les serveurs de téléphonie]",
    "AnyPartition": "[Toute partition]",
    "AnyDevices": "[Tout appareil]",
    "AnyAgents": "[Tout agent ACD]",
    "AnyAgentForDevice": "[Any At Set Device]",
    "AnyDeviceForAgent": "[Any With Set ACD Agent]",
    "DeviceValidation": "Un administrateur ne peut pas avoir un niveau d'autorisation de périphérique défini",
    "AgentValidation": "Un administrateur ne peut pas avoir un niveau de permission d'agent défini",
    "PermissionsLanguage_PermissionsNote": "Définir les autorisations du niveau d'accès de l'utilisateur.",
    "PermissionsLanguage_CmEnvironment": "CME :",
    "PermissionsLanguage_TelServer": "Serveur de téléphonie :",
    "PermissionsLanguage_Partition": "Partition :",
    "PermissionsLanguage_Device": "Groupe\/Dispositif :",
    "PermissionsLanguage_AndOrAgent": "Agent :",
    "NAME": "PermissionsLanguage",
    "EssentialsDeviceValidation": "Un utilisateur Essentials doit avoir un dispositif d'autorisation défini",
    "EssentialsDeviceValidation_MST": "Un utilisateur CXA Standard doit avoir un dispositif d'autorisation défini",
    "PermissionsLanguage_SynchroniseSupervisorPermissions": "Synchronisation des autorisations du superviseur à partir de la plate-forme téléphonique"
}